import httpClient from "@/http/httpClient";
import store from "@/store";

export const LOADING_STATUS = {
  FETCHING: "fetching",
  REFRESHING: "refreshing",
  COMPLETED: "completed",
  FAILED: "failed",
};
// import { LOADING_STATUS } from "@/helpers/loadingStatus";

const module = {
  namespaced: true,
  state: () => {
    return {
      orders: [], //{orderData, locations:[ locaiton: {items: items} ]}
      ordersInProgress: [],
    };
  },
  getters: {
    getOrderById: (state) => (orderId) => {
      const order = state.orders.find((x) => x.order_id === orderId);
      return order;
    },
  },
  mutations: {
    pushToOrder(state, payload) {
      const orders = state.orders;
      let orgOrder = orders.find((x) => x.order_id === payload.order_id);
      if (orgOrder) {
        orgOrder = { ...payload };
      } else {
        orders.push(payload);
      }
      state.orders = [...orders];
    },
    removeExtraLocations(state, { orderId, newLocations }) {
      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      const locations = _.get(order, "locations", false);

      if (!locations) return;

      for (let loc in locations) {
        if (!newLocations[loc]) {
          delete locations[loc];
        }
      }
      state.orders = [...orders];
    },

    setLocationsForOrder(state, { orderId, locations: newLocations }) {
      store.commit("orders/removeExtraLocations", { orderId, newLocations });

      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      const locations = _.get(order, "locations", false);
      if (!locations) order.locations = {};

      for (let nLoc in newLocations) {
        const isAvailable = _.get(order, `locations.${nLoc}`, false);
        if (!isAvailable) {
          order.locations[nLoc] = newLocations[nLoc];
        } else {
          order.locations[nLoc] = {
            ...newLocations[nLoc],
            items: order.locations[nLoc].items,
          };
        }
      }
      state.orders = [...orders];
    },
    setItemsForLocation(state, { orderId, location, data }) {
      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      const l = _.get(order, `locations[${location}]`, false);
      order.locations[location].items = data.items;
      state.orders = [...orders];
    },
    setLocationLoadingStatus(state, { orderId, location, value }) {
      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      order.locations[location]["loadingStatus"] = value;
      state.orders = [...orders];
    },
    setSummaryLoadingStatus(state, { orderId, value }) {
      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      _.set(order, "summary.loadingStatus", value);
      state.orders = [...orders];
    },

    setOrderSummaryToAnOrder(state, { orderId, data }) {
      const orders = state.orders;
      const order = orders.find((x) => x.order_id === orderId);
      order.summary["data"] = data;
      state.orders = [...orders];
    },
    setOrderFetchingCompleted(state, orderId) {
      state.ordersInProgress = state.ordersInProgress.filter(
        (x) => x !== orderId
      );
    },
    setOrderFetchingStarted(state, orderId) {
      state.ordersInProgress = [...state.ordersInProgress, orderId];
    },
  },
  actions: {
    async fetchOrderSummary({ commit, state, dispatch, getters }, { orderId }) {
      const response = await httpClient.get(`orders/${orderId}/summary`);
      return response;
    },
    async fetchItemsForLocation(
      { commit, state, dispatch, getters },
      { orderId, location }
    ) {
      const orders = state.orders;

      const hasItems = () => {
        const order = orders.find((x) => x.order_id === orderId);
        const locationItems = _.get(order, `locations[${location}].items`, {});
        return !_.isEmpty(locationItems);
      };

      commit("setLocationLoadingStatus", {
        orderId,
        location,
        value: hasItems() ? LOADING_STATUS.REFRESHING : LOADING_STATUS.FETCHING,
      });

      const response = await httpClient.get(
        `orders/${orderId}/locations/${encodeURIComponent(location)}`
      );
      commit("setItemsForLocation", {
        orderId,
        location,
        data: response.data.data,
      });
      commit("setLocationLoadingStatus", {
        orderId,
        location,
        value: LOADING_STATUS.COMPLETED,
      });
      return response;
    },

    async fetchLocationsForOrderId(
      { commit, state, dispatch, getters },
      orderId
    ) {
      const response = await httpClient.get(`orders/${orderId}/locations`);
      commit("setLocationsForOrder", {
        orderId,
        locations: response.data.data,
      });
      return response;
    },

    async fetchOrderById(
      { commit, state, dispatch, getters },
      { orderId, fresh }
    ) {
      try {
        if (state.ordersInProgress.find((x) => x === orderId)) {
          return;
        }

        const cachedOrder = getters.getOrderById(orderId);
        if (!fresh && cachedOrder) return true;

        commit("setOrderFetchingStarted", orderId);
        const response = await httpClient
          .get(`orders/${orderId}`)
          .then((response) => {
            commit("pushToOrder", response.data.data);

            const hasSummary = () => {
              const order = state.orders.find((x) => x.order_id === orderId);
              const summary = _.get(order, "summary.data", {});
              return !_.isEmpty(summary);
            };

            commit("setSummaryLoadingStatus", {
              orderId,
              value: hasSummary()
                ? LOADING_STATUS.REFRESHING
                : LOADING_STATUS.FETCHING,
            });
            dispatch("fetchOrderSummary", { orderId })
              .then((summaryResponse) => {
                commit("setOrderSummaryToAnOrder", {
                  orderId,
                  data: summaryResponse.data.data,
                });
                commit("setSummaryLoadingStatus", {
                  orderId,
                  value: LOADING_STATUS.COMPLETED,
                });
              })
              .catch((error) => {
                commit("setSummaryLoadingStatus", {
                  orderId,
                  value: LOADING_STATUS.FAILED,
                });
              });

            dispatch("fetchLocationsForOrderId", orderId).then(
              (locationResponse) => {
                const actions = [];
                for (let loc in locationResponse.data.data) {
                  actions.push(
                    dispatch("fetchItemsForLocation", {
                      orderId,
                      location: loc,
                    })
                  );
                }
                Promise.all(actions)
                  .then((res) => {
                    commit("setOrderFetchingCompleted", orderId);
                  })
                  .catch((error) => {
                    console.error(
                      "Error occured while fetching items for locations: ",
                      error
                    );
                  });
              }
            );
            return response;
          });
        return true;
      } catch (error) {
        console.error("Fetch order", error);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      } finally {
      }
    },
  },
};

export const NAMESPACES = {
  ORDERS_FOR_CUSTOMERS_PAGE: "ordersForCustomersPage",
  ORDERS_FOR_DEALERS_PAGE: "ordersForDealersPage",
};

export const registerModule = (namespace) => {
  if (!store.hasModule(namespace)) store.registerModule(namespace, module);
};

export const unregisterModule = (namespace) => {
  if (store.hasModule(namespace)) store.unregisterModule(namespace);
};

export default module;
